import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11 19.846c-.201 0-.504-.019-.788-.12-3.502-1.2-9.066-5.454-9.066-11.76 0-3.209 2.594-5.812 5.784-5.812 1.55 0 2.998.605 4.07 1.687a5.7 5.7 0 0 1 4.07-1.687c3.19 0 5.784 2.603 5.784 5.812 0 1.109-.165 2.2-.495 3.245a.687.687 0 1 1-1.31-.413c.284-.907.43-1.86.43-2.823 0-2.448-1.98-4.437-4.409-4.437-1.393 0-2.686.651-3.52 1.77-.257.348-.843.348-1.1 0a4.36 4.36 0 0 0-3.52-1.77c-2.429 0-4.409 1.99-4.409 4.437 0 6.27 6.022 9.744 8.14 10.468.055.019.183.046.34.046.375 0 .687.312.687.688s-.312.669-.688.669"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16.262 19.938a3.623 3.623 0 0 1-3.621-3.621 3.623 3.623 0 0 1 3.62-3.621 3.623 3.623 0 0 1 3.621 3.62 3.623 3.623 0 0 1-3.62 3.622m0-5.867a2.25 2.25 0 0 0-2.246 2.246 2.25 2.25 0 0 0 2.246 2.246 2.25 2.25 0 0 0 2.245-2.246 2.25 2.25 0 0 0-2.245-2.246"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M19.745 20.488a.68.68 0 0 1-.486-.202l-.917-.917a.69.69 0 0 1 0-.971.69.69 0 0 1 .972 0l.917.916a.69.69 0 0 1 0 .972.72.72 0 0 1-.486.202"
    }, null, -1)
  ]))]))
}
export default { render: render }